import { boxTypeFilterItems, getOptions } from '@/shared/SelectData'
import {
  connectionState,
  getStatusOptions,
  templateState
} from '@/shared/Status'
import { getFormatMessage } from '@/utils/utils'
import { DownOutlined, FilterOutlined, SearchOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  Drawer,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Space
} from 'antd'
import React, { useState } from 'react'
import { BoxToolbarProps } from '../interface'

export const BoxToolbar: React.FC<BoxToolbarProps> = (
  props: BoxToolbarProps
) => {
  const { onMenuItemClick } = props
  const [keyword, setKeyword] = useState<string>()
  const [connState, setConnState] = useState<number>()
  const [tempState, setTempState] = useState<number>()
  const [remark, setRemark] = useState<string>()
  const [filterVisible, setFilterVisible] = useState<boolean>(false)
  const formatMessage = getFormatMessage()
  const [form] = Form.useForm()

  const handleClearClick = () => {
    setKeyword(undefined)
    setConnState(undefined)
    setTempState(undefined)
    form.resetFields()
    if (props.onSearch) {
      props.onSearch({})
    }
  }

  const handleSearchClick = () => {
    if (props.onSearch) {
      props.onSearch({
        keyword: keyword,
        connectionState: connState,
        templateState: tempState,
        remark: remark
      })
    }
  }

  const handleImportClick = () => {
    if (props.onImport) {
      props.onImport()
    }
  }

  // const handleUpdateTemplateClick = () => {
  //   if (props.onTemplateUpdate) {
  //     props.onTemplateUpdate()
  //   }
  // }

  const handleFilterClick = () => {
    setFilterVisible(true)
  }

  const handleFilterOk = () => {
    setFilterVisible(false)
    if (props.onSearch) {
      const args = form.getFieldsValue()
      if (args.boxType) {
        if (args.boxType === 999) {
          args.boxType = [2, 4, 7]
        } else {
          args.boxType = [args.boxType]
        }
      }
      props.onSearch(args)
      setFilterVisible(false)
    }
  }

  const menu = (
    <Menu>
      <Menu.Item
        key='contextmenu.delete'
        onClick={() => onMenuItemClick?.('delete')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.delete' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.firmware'
        onClick={() => onMenuItemClick?.('firmware')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.firmware' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.template'
        onClick={() => onMenuItemClick?.('template')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.template' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.connection'
        onClick={() => onMenuItemClick?.('connection')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.connection' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.time'
        onClick={() => onMenuItemClick?.('time')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.time' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.clean'
        onClick={() => onMenuItemClick?.('clean')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.clean' })}
      </Menu.Item>
    </Menu>
  )

  return (
    <div>
      <Row style={{ marginBottom: 16 }}>
        <Col span={19}>
          <Space>
            <Input
              placeholder={formatMessage({ id: 'app.box.toolbar.keyword' })}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              allowClear={true}
            />
            {props.showRemark && (
              <Input
                placeholder={formatMessage({ id: 'app.box.toolbar.remark' })}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                allowClear={true}
              />
            )}
            {(props.showConnectionStates == undefined
              ? true
              : props.showConnectionStates) && (
              <Select
                placeholder={formatMessage({
                  id: 'app.box.toolbar.connectionState'
                })}
                style={{ width: 200 }}
                onChange={(value) => setConnState(value)}
                value={connState}
                allowClear={true}
              >
                {getStatusOptions(connectionState)}
              </Select>
            )}
            {(props.showTemplateStates == undefined
              ? true
              : props.showTemplateStates) && (
              <Select
                placeholder={formatMessage({
                  id: 'app.box.toolbar.templateState'
                })}
                style={{ width: 200 }}
                onChange={(value) => setTempState(value)}
                value={tempState}
                allowClear={true}
              >
                {getStatusOptions(templateState)}
              </Select>
            )}

            <Button type='link' onClick={handleClearClick}>
              {formatMessage({ id: 'app.box.toolbar.clear' })}
            </Button>
            <Button
              type='primary'
              icon={<SearchOutlined />}
              onClick={handleSearchClick}
            >
              {formatMessage({ id: 'app.box.toolbar.search' })}
            </Button>
            {(props.showFilter == undefined ? true : props.showFilter) && (
              <Button
                icon={<FilterOutlined />}
                onClick={handleFilterClick}
              ></Button>
            )}
          </Space>
        </Col>

        <Col span={5}>
          <Space align='end'>
            {(props.showImport == undefined ? true : props.showImport) && (
              <Button type='primary' onClick={handleImportClick}>
                {formatMessage({ id: 'app.box.toolbar.import' })}
              </Button>
            )}
            {(props.showOperations == undefined
              ? true
              : props.showOperations) && (
              <Dropdown overlay={menu} trigger={['click']}>
                <Button>
                  <Space>
                    {formatMessage({ id: 'app.box.toolbar.batch' })}
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            )}
          </Space>
        </Col>
      </Row>

      <Drawer
        maskClosable={false}
        title={formatMessage({ id: 'app.box.toolbar.moreFilter' })}
        visible={filterVisible}
        onClose={() => setFilterVisible(false)}
        width={400}
      >
        <Form form={form} layout='vertical'>
          <Form.Item
            label={formatMessage({ id: 'app.box.toolbar.filter.boxType' })}
            name='boxType'
          >
            <Select>{getOptions(boxTypeFilterItems)}</Select>
          </Form.Item>

          <Form.Item
            label={formatMessage({ id: 'app.box.toolbar.filter.templateName' })}
            name='templateName'
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={formatMessage({ id: 'app.box.toolbar.filter.remark' })}
            name='remark'
          >
            <Input />
          </Form.Item>

          <Form.Item style={{ textAlign: 'right' }}>
            <Space align='end'>
              <Button onClick={() => setFilterVisible(false)}>
                {formatMessage({ id: 'app.box.toolbar.filter.cancel' })}
              </Button>
              <Button type='primary' onClick={handleFilterOk}>
                {formatMessage({ id: 'app.box.toolbar.filter.ok' })}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  )
}
